import React from "react";
import { useToastDispatchContext } from "../../contexts/ToastContext";
import { IPlacement, IType } from "../../hooks/useToasts";
import classnames from "classnames";
import styles from "./Toast.module.scss";
import {
  CloseIco,
  ErrorIco,
  InfoToastIco,
  SuccessIco,
  WarningIco,
} from "../../assets/customIcons";

export interface IToast {
  id?: any;
  type?: IType;
  message?: string;
  placement?: IPlacement;
}

const icons = {
  succes: <SuccessIco />,
  info: <InfoToastIco />,
  warning: <WarningIco />,
  error: <ErrorIco />,
};

export const Toast: React.FC = ({ id, type, message }: IToast) => {
  const dispatch = useToastDispatchContext();

  return (
    <div className={classnames(styles.toast, styles[type])}>
      <div className={styles.body}>
        <div className={styles.left}>{icons[type]}</div>
        <span className={styles.description}>{message}</span>
        <div className={styles.end}>
          <CloseIco onClick={() => dispatch({ type: "DELETE_TOAST", id })} />
        </div>
      </div>
    </div>
  );
};
